import { render, staticRenderFns } from "./r-table.vue?vue&type=template&id=2f351262&scoped=true"
import script from "./r-table.vue?vue&type=script&lang=js"
export * from "./r-table.vue?vue&type=script&lang=js"
import style0 from "./r-table.vue?vue&type=style&index=0&id=2f351262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f351262",
  null
  
)

export default component.exports